import styles from "./loading-indicator.module.css";

export const LoadingIndicator = () => {
  return <div className={styles.loading}></div>;
};
